/**
 * nodash, aka nunderscore
 * es6 implementations of lodash/underscore methods
 */

export const isNull = (value) => {
    return value === null;
};

export const isUndefined = (value) => {
    return value === undefined;
};

export const _isNaN = (value) => {
    // eslint-disable-next-line no-self-compare
    return value !== value;
};

export const findWhere = (array, criteria) => {
    return array.find((item) => Object.keys(criteria).every((key) => item[key] === criteria[key]));
};

export const findKey = (object, predicate) => {
    const keys = Object.keys(object);
    let key;
    for (let i = 0, length = keys.length; i < length; i++) {
        key = keys[i];
        if (predicate(object[key], key, object)) {
            return key;
        }
    }
};

/* standard debounce function */
export const debounce = (callback, delay = 1000) => {
    let timeout;

    const debouncedFunction = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, delay);
    };

    /* Adds a cancel method to the debounced function */
    debouncedFunction.cancel = () => {
        clearTimeout(timeout);
    };

    return debouncedFunction;
};

export const invert = (obj) => {
    return Object.entries(obj).reduce((ret, [key, value]) => {
        ret[value] = key;
        return ret;
    }, {});
};
